<div class="header">
    <h5 class="title-box">
        {{ title }}
    </h5>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">
        <i class="fa fa-solid fa-xmark"></i>
    </button>
</div>

<div class="body">
    @if (description) {
    <div class="description">
        {{ description }}
    </div>
    }

    @if (showRefundNotice()) {
    <div class="refund-notice" role="status">
        <div class="refund-notice-header">
            <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
            <span>Restituição da fee ao comprador</span>
        </div>
        <p class="refund-notice-description">
            Como a fee da plataforma já foi paga, ao confirmar o cancelamento será iniciado o processo de
            devolução do valor ao comprador
            @if (refundBuyerName()) {
                <strong>{{ refundBuyerName() }}</strong>
            }.
            Um e-mail será enviado solicitando os dados bancários para conclusão do reembolso.
        </p>
    </div>
    }

    <div class="reason-container">
    <div class="title-reason">Selecione o motivo do cancelamento:</div>
    <mat-radio-group [ngModel]="reason()" (ngModelChange)="onReasonChange($event)">
        @for (r of reasons; track r.value) {
        <mat-radio-button [value]="r.value">{{ r.label }}</mat-radio-button>
        }
    </mat-radio-group>

    @if (isOtherReason()) {
        <textarea
            class="w-100 mt-3"
            name="otherReasonDetail"
            id="otherReasonDetail"
            rows="4"
            maxlength="150"
            placeholder="Digite o motivo do cancelamento"
            [ngModel]="otherReasonDetail()"
            (ngModelChange)="onOtherReasonDetailChange($event)"
        ></textarea>
        <small class="text-muted">{{ otherReasonDetail().length }}/{{ maxOtherReasonLength }}</small>
    }
    </div>

    @if (data.vehicle.sold && data.currentBidderInfo) {
    <div class="mt-4">
        <label class="text-primary font-weight-bold">
            Você deseja bloquear o comprador {{ data.currentBidderInfo.name }} de ver suas próximas ofertas?
        </label>
        <mat-slide-toggle class="d-block" [ngModel]="addDealerBlacklist()"
            (ngModelChange)="addDealerBlacklist.set($event)">
            {{ addDealerBlacklist() ? "SIM" : "NÃO" }}
        </mat-slide-toggle>
    </div>
    }
</div>

<div class="modal-footer mt-3">
    <div class="row">
        <div class="col-12 text-center">
            @if (data.vehicle.active || data.vehicle.waitingPublication || (data.vehicle.sold && data.canCancelSell)) {
            <button class="btn btn-primary btn-rounded" [disabled]="!canConfirm()" (click)="confirm()">
                CONFIRMAR
            </button>
            }
        </div>
        <div class="col-12 text-center">
            <button class="btn btn-link" style="margin-top: 8px" (click)="close()">
                {{ closeLabel }}
            </button>
        </div>
    </div>
</div>